<template>
    <div class="list-actions">
        <span
            :class="{
                'material-symbols-outlined': true,
                icon: true,
                'button-filter': true,
                active: current === 'filtering',
            }"
            @click="$emit('update', 'filtering')"
        >
            filter_list
        </span>
        <span
            :class="{
                'material-symbols-outlined': true,
                icon: true,
                'button-sort': true,
                active: current === 'sorting',
            }"
            @click="$emit('update', 'sorting')"
        >
            swap_vert
        </span>
    </div>
</template>
<script>
export default {
    name: "ListActions",
    props: {
        current: {
            type: String,
            required: true,
        },
    },
    emits: ["update"],
};
</script>
